/**
 * @generated SignedSource<<ca5873055aba2b17b1b2cc4043a58dbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TheoryDeleteMutation$variables = {
  backLang?: string | null;
  id: string;
};
export type TheoryDeleteMutation$data = {
  readonly deleteTheory: {
    readonly id: string;
    readonly theory: {
      readonly sCardId: string;
    } | null;
  } | null;
};
export type TheoryDeleteMutation = {
  response: TheoryDeleteMutation$data;
  variables: TheoryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "backLang",
        "variableName": "backLang"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SCard",
    "kind": "LinkedField",
    "name": "deleteTheory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "langNative",
            "variableName": "backLang"
          }
        ],
        "concreteType": "SCardTheory",
        "kind": "LinkedField",
        "name": "theory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sCardId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TheoryDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TheoryDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a9a29116a5b60e993f78743e8bc7efae",
    "id": null,
    "metadata": {},
    "name": "TheoryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TheoryDeleteMutation(\n  $id: ID!\n  $backLang: String\n) {\n  deleteTheory(id: $id, backLang: $backLang) {\n    id\n    theory(langNative: $backLang) {\n      sCardId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "05d44708a353e77bb861955340784f47";

export default node;
